import { useMemo } from 'react';
import { Card, Metric, Value, SectionHeader } from '../../blocks';
import { genOriginAttributes, genDestinationAttributes, genAttributes } from '@onward-delivery/core';
import zipcode_to_timezone from 'zipcode-to-timezone';
import { dateFormatter } from '../../formatters';
import { css } from '@emotion/react';
import { Grid } from '@material-ui/core';

const OrderInfoCard = ({ order, claim }) => {
    const isReturn = useMemo(() => {
        return ['return', 'wh_return'].includes(order.order_type);
    }, [order]);

    const { pickup, dropoff } = useMemo(() => {
        const { city: pucity, state: pustate } = genOriginAttributes(order, !!claim.middle_mile_carrier_id);
        const { city: dcity, state: dstate } = genDestinationAttributes(order, !!claim.middle_mile_carrier_id);
        return {
            pickup: `${order[pucity]}, ${order[pustate]}`,
            dropoff: `${order[dcity]}, ${order[dstate]}`,
        };
    }, [order, claim]);

    const tz = useMemo(() => {
        const { zip } = genAttributes(order);
        return zipcode_to_timezone.lookup(zip) || 'America/New_York';
    }, [order]);

    return (
        <Card>
            <Grid item>
                <SectionHeader>
                    {pickup} - {dropoff}
                </SectionHeader>
            </Grid>
            <Grid
                item
                css={css`
                    margin-bottom: 1rem;
                `}
            >
                <SectionHeader>
                    {order.oms ? 'Marketplace Order' : 'Internal Order'} / {isReturn ? 'Return' : 'Delivery'}
                </SectionHeader>
            </Grid>
            <Grid item>
                <Metric label="OD #" value={order.order_number} />
            </Grid>
            <Grid item>
                <Metric label="PO #" value={order.po_number} />
            </Grid>
            <Grid item>
                <Metric label="Ref #" value={order.reference_id} />
            </Grid>
            <Grid item>
                <Metric label="Created Date" value={order.created_at} formatter={dateFormatter} />
            </Grid>
            <Grid item>
                <Metric
                    label="Estimated Delivery Start"
                    value={order.estimated_delivery_range_start}
                    formatter={dateFormatter}
                    params={{ tz }}
                />
            </Grid>
            <Grid item>
                <Metric
                    label="Estimated Delivery End"
                    value={order.estimated_delivery_range_end}
                    formatter={dateFormatter}
                    params={{ tz }}
                />
            </Grid>
            <Grid item>
                <Metric label="Scheduled Pickup" value={order.pickup_date} formatter={dateFormatter} params={{ tz }} />
            </Grid>
            <Grid item>
                <Metric
                    label="Scheduled Delivery"
                    value={order.delivery_date}
                    formatter={dateFormatter}
                    params={{ tz }}
                />
            </Grid>
            <Grid item>
                <Metric label="Delivery Speed" value={order.is_same_day ? 'Same Day' : 'Standard'} />
            </Grid>
            <Grid item>
                <Metric label="Tags" value={(order.tags || []).map((tag) => tag.tag).join(', ')} />
            </Grid>
            <Grid item>
                <Metric
                    label="Equipment"
                    value={Object.entries({
                        ...(order.recommended_equipment || {}),
                        ...(order.equipment_overrides || {}),
                    })
                        .filter(([_, value]) => !!value)
                        .map(([key]) => key)
                        .join(', ')}
                />
            </Grid>
        </Card>
    );
};

export default OrderInfoCard;
